import { combineReducers } from 'redux';

import { RootState } from '@/store/redux';

import conditionFormReducer from './condition';
import tradeinDealerReducer from './dealer';
import tradeInPricesReducer from './prices';
import sequenceFormReducer from './sequence';
import tradeinPageReducer from './ui';
import valuationLinkReducer from './valuation';
import vinFormReducer from './vin';

const tradeInReducer = combineReducers({
  sequence: sequenceFormReducer,
  vin: vinFormReducer,
  valuation: valuationLinkReducer,
  condition: conditionFormReducer,
  dealer: tradeinDealerReducer,
  ui: tradeinPageReducer,
  prices: tradeInPricesReducer,
});

export default tradeInReducer;

export const selectTradeInState = (state: RootState) => state.pages.tradeIn;
